import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import { Button, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import injectSheet from 'react-jss';
import { signOut } from '../../lib/firebase';
import { getProfile } from '../../store/ducks/profile';
import { classesPropType, profilePropType } from '../prop-types';

const styles = {
  button: {
    padding: '0 5px',
  },
};

function LogoutLink({ profile, classes }) {
  const hasProfile = Boolean(profile);

  const { t } = useTranslation();

  const onSignOut = useCallback(
    () => {
      signOut()
        .then(() => {
          notification.success({
            message: t('feedback.logout.message'),
          });
        })
        .catch(noop);
      return false;
    },
    [],
  );

  if (!hasProfile) return null;

  return (
    <Button className={classes.button} type="link" onClick={onSignOut}>
      {t('actions.logout')}
    </Button>
  );
}

LogoutLink.propTypes = {
  profile: profilePropType,
  classes: classesPropType.isRequired,
};

LogoutLink.defaultProps = {
  profile: undefined,
};

function mapStateToProps(state) {
  return {
    profile: getProfile(state),
  };
}

export default connect(mapStateToProps)(injectSheet(styles)(LogoutLink));
